module.exports = __webpack_public_path__ + "img/noEvaluate.1f36e760.png";